import React from 'react';

const AssignAdmin = () => {
  return <div>AssignAdmin</div>;
};

export default AssignAdmin;
